// Meet dates for the home page templates, always in Jamaica time
const TZ = 'America/Jamaica';

const part = (iso, options) =>
  new Intl.DateTimeFormat('en-GB', { timeZone: TZ, ...options }).format(
    new Date(iso),
  );

const day = (iso) => part(iso, { day: 'numeric' });
const month = (iso) => part(iso, { month: 'short' });
const year = (iso) => part(iso, { year: 'numeric' });

// "19–29 Oct", "30 Oct – 2 Nov" or "23 Oct", plus the year of the end date
export function dateRange(start, end) {
  if (!start) return { range: '', year: '' };
  const last = end || start;
  let range;
  if (day(start) === day(last) && month(start) === month(last)) {
    range = `${day(start)} ${month(start)}`;
  } else if (month(start) === month(last)) {
    range = `${day(start)}–${day(last)} ${month(last)}`;
  } else {
    range = `${day(start)} ${month(start)} – ${day(last)} ${month(last)}`;
  }
  return { range, year: year(last) };
}

// "23 October 2026", for news dates
export function longDate(iso) {
  return iso
    ? part(iso, { day: 'numeric', month: 'long', year: 'numeric' })
    : '';
}

// An item's publication date, or its creation date when it has none.
// Plone reports a missing date as 1969-12-31 (an empty value), which would
// otherwise show as "30 December 1969" in Jamaica time.
export function publishedDate(item) {
  const valid = (iso) => iso && new Date(iso).getFullYear() > 1970;
  if (valid(item.effective)) return item.effective;
  return valid(item.created) ? item.created : null;
}

// Same rule as the backend's live-status: "Live now" forces it, "No live
// results" excludes it, otherwise live between start and end
export function isMeetLive(item, now = new Date()) {
  if (item.live_results === 'live') return true;
  if (item.live_results === 'none' || !item.start) return false;
  const start = new Date(item.start);
  const end = new Date(item.end || item.start);
  return start <= now && now <= end;
}

// For display titles: the longest word's length, as --asaj-longest, which
// the theme uses to size the title so that word never has to be split
export function titleFit(title = '') {
  const longest = Math.max(0, ...title.split(/\s+/).map((word) => word.length));
  return { '--asaj-longest': longest };
}
